import React, { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LOGO_URL } from "@/lib/constants";
import { MailCheck } from "lucide-react";

export default function CheckEmail() {
  const { resendVerification } = useAuth();
  const [params] = useSearchParams();
  const email = params.get("email") || "";
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  const resend = async () => {
    if (!email) return;
    setBusy(true);
    try { await resendVerification(email); setSent(true); } catch (e) {} finally { setBusy(false); }
  };

  return (
    <div className="min-h-[calc(100vh-4rem)] flex items-center justify-center p-8">
      <div className="w-full max-w-md text-center" data-testid="check-email-page">
        <img src={LOGO_URL} alt="OnchainLyfe" className="h-8 mx-auto mb-10" />
        <div className="inline-flex h-14 w-14 items-center justify-center rounded-2xl bg-[#ccff00]/10 border border-[#ccff00]/20 mb-6">
          <MailCheck className="h-7 w-7 text-[#ccff00]" />
        </div>
        <h1 className="font-display text-3xl font-bold">Confirm your email</h1>
        <p className="text-zinc-400 text-sm mt-3 leading-relaxed">
          We've sent a confirmation link to{" "}
          {email ? <span className="text-white font-medium">{email}</span> : "your inbox"}.
          Click it to activate your account. The link expires in 24 hours.
        </p>
        <div className="mt-8 text-sm text-zinc-500">
          {sent ? (
            <span data-testid="check-email-resent" className="text-[#ccff00]">A new link is on its way.</span>
          ) : (
            <>Didn't get it?{" "}
              <button data-testid="check-email-resend" disabled={busy} onClick={resend}
                className="text-[#ccff00] hover:underline disabled:opacity-60">
                {busy ? "Sending…" : "Resend email"}
              </button>
            </>
          )}
        </div>
        <p className="text-sm text-zinc-500 mt-6">
          <Link to="/login" className="text-[#ccff00] hover:underline">Back to log in</Link>
        </p>
      </div>
    </div>
  );
}
